// =====================================================================
// lib/telechargement.js — enregistrer un fichier reçu du serveur (22-10-2026)
// =====================================================================
// Réponse axios en `responseType: 'blob'` → fichier enregistré par le navigateur, sous le nom donné par le
// serveur (Content-Disposition), sinon `defaut`. Une erreur arrive elle aussi en blob : messageDeBlob la relit.
// =====================================================================

export function enregistrerReponse(reponse, defaut) {
  const cd = reponse?.headers?.['content-disposition'] || '';
  const nom = (cd.match(/filename="([^"]+)"/) || [])[1] || defaut;
  const url = URL.createObjectURL(reponse.data);
  const a = document.createElement('a');
  a.href = url;
  a.download = nom;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
  return nom;
}

/** Message lisible d'une erreur dont le corps est un blob (JSON { message } du serveur), sinon `defaut`. */
export async function messageDeBlob(err, defaut = 'Erreur lors de l\'export') {
  const corps = err?.response?.data;
  if (corps && typeof corps.text === 'function') {
    try { return JSON.parse(await corps.text()).message || defaut; } catch { return defaut; }
  }
  return err?.response?.data?.message || err?.message || defaut;
}
